import { Component, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";
import { AuthService } from "src/app/core/helpers/auth.service";
import { CoreService } from "src/app/core/helpers/core.service";
import { DataServiceService } from "src/app/core/helpers/data-service.service";
import { GaService } from "src/app/core/helpers/ga.service";
import { WeatherBonusOrchestratorService } from "src/app/core/helpers/weather-bonus-orchestrator.service";
import { WeatherBonusFrontendResult } from "src/app/core/models/weather-bonus.models";

@Component({
  selector: "loyaltic-upload-receipt",
  templateUrl: "./upload-receipt.component.html",
  styleUrls: ["./upload-receipt.component.scss"],
})
export class UploadReceiptComponent implements OnInit {
  receipt: any;
  Quantity = 1;
  receiptSrc: any;
  removeLocalProductList = true;
  ReceiptName = "";
  culture = "";
  product1 = null;
  product2 = null;
  product3 = null;
  product4 = null;
  product5 = null;
  prodQuantityOne = 0;
  prodQuantityTwo = 0;
  prodQuantityThree = 0;
  prodQuantityFour = 0;
  prodQuantityFive = 0;
  List = [];
  @ViewChild("tryagainReceiptUpload", { static: false })
  tryagainReceiptUploadRef: any;
  @ViewChild("uploadAnimation", { static: false }) uploadAnimationRef: any;
  @ViewChild("thankyouApprovedPopup", { static: false }) thankyouApprovedPopupRef: any;
  @ViewChild("uploadHelp", { static: false }) uploadHelpPopupRef: any;
  public modalRef: BsModalRef;

  showConfirmReceiptUploadPopUp = false;
  @Output() receiptUploadSuccess = new EventEmitter<any>();

  popupConfig = {
    ignoreBackdropClick: true,
    class:
      "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
  };

  confirmPopupConfig = {
    ignoreBackdropClick: true,
    class: "lyltc modal-md modal-dialog-centered",
  };
  showSurvey = true;
  IsKotiPizzaStore = false;
  isFinnish = false;
  approvedPopupTitle = "";
  approvedPopupPoints = "";
  approvedPopupPointsPrefix = "";
  approvedPopupPointsValue = "";
  approvedPopupPointsSuffix = "";
  approvedPopupBonusMessage = "";
  approvedPopupBonusPrefix = "";
  approvedPopupBonusPoints = "";
  approvedPopupBonusSuffix = "";
  approvedPopupBonusIsWarning = false;
  approvedPopupBonusIsSuccess = false;
  productList: any;
  productQuantity = new Array(10);
  selectedProducts = [
    {productId: null, productName: null, quantity: 0}
  ]

  constructor(
    private authService: AuthService,
    private coreService: CoreService,
    private toast: ToastrService,
    private translate: TranslateService,
    private router: Router,
    private dataService: DataServiceService,
    private modalService: BsModalService,
    private gaService: GaService,
    private weatherBonusOrchestrator: WeatherBonusOrchestratorService
  ) {
    this.culture = translate.getDefaultLang();
    if (this.culture == 'fi-FI') {
      this.isFinnish = true;
    }

  }

  ngOnInit() {
    if (localStorage.getItem("surveyTaken") == "true") {
      this.showSurvey = false;
    }

    this.loadProducts();
  }

  loadProducts() {
    this.coreService.getProducts().then((apiResponse: any) => {
      const apiResult = apiResponse && apiResponse.result ? apiResponse.result : {};
      const categoryProducts = this.flattenProductCategories(apiResult.categories || []);

      this.productList = categoryProducts.length
        ? categoryProducts
        : this.normalizeProducts(apiResult.purchasedProducts || []);
      this.restoreSelectedProducts();
    });
  }

  flattenProductCategories(productCategoryData: any[]) {
    if (!Array.isArray(productCategoryData)) {
      return [];
    }

    return productCategoryData.reduce((products: any[], item: any) => {
      if (item && Array.isArray(item.products)) {
        item.products.forEach((product: any) => {
          products.push({
            productId: product.productId || null,
            name: product.name,
            category: item.category || product.category || "Other",
            pointsPerProduct: product.pointsPerProduct || 0
          });
        });
        return products;
      }

      if (item && item.name) {
        products.push({
          productId: item.productId || null,
          name: item.name,
          category: item.category || "Other",
          pointsPerProduct: item.pointsPerProduct || 0
        });
      }

      return products;
    }, []);
  }

  normalizeProducts(apiProducts: any[]) {
    return (apiProducts || []).map((product: any) => ({
      productId: product.productId || product.ProductId || product.id || null,
      name: product.name || product.ProductName || product.productName,
      category: product.category || product.Category || "Other",
      pointsPerProduct: product.pointsPerProduct || product.PointsPerProduct || product.points || 0
    })).filter((product: any) => product.name);
  }

  restoreSelectedProducts() {
    if (localStorage.getItem('productList')) {
      let storedProducts = JSON.parse(localStorage.getItem('productList'));
      if (storedProducts.length > 0) {
        this.selectedProducts  = [];
        storedProducts.map((product:any) => {
          let data = {
            productId: product.ProductId,
            productName : product.ProductName,
            quantity: product.Quantity
          }
          this.selectedProducts.push(data);
        })
      }
    }
  }

  // onReceiptSelect(event) {
  //   this.receipt = event.target.files[0];
  // }
  
  onReceiptSelect(event) {
    this.receipt = event.target.files[0];
    this.ReceiptName = this.receipt.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement("img");
        img.src = e.target.result;
        this.receiptSrc = e.target.result;
      };
    }
  }
  openProductHelp() {
    this.modalRef = this.modalService.show(
      this.uploadHelpPopupRef,
      this.popupConfig = {
        ignoreBackdropClick: false,
        class:
          "lyltc animation modal-md modal-dialog-centered modal-dialog-animation",
      }
    );
  }
  showAnimationPopup() {
    this.modalRef = this.modalService.show(
      this.uploadAnimationRef,
      this.popupConfig
    );
  }

  checkQuantity() {
    return this.selectedProducts.filter((prod:any) => prod.quantity == 0).length == 0;
  }

  onProductSelect(name: string, index: number) {
    const product = this.findProductByName(name);
    this.selectedProducts[index].productId = product ? product.productId : '';
  }

  findProductByName(name: string) {
    return this.productList && this.productList.find((p: any) => p.name === name);
  }

  addMoreProduct() {
    if (this.selectedProducts.length >= 10) {
      return;
    }
    let prod = {productId: null, productName: null, quantity: 0};
    this.selectedProducts.push(prod);
  }

  removeProductAt(index: number) {
    this.selectedProducts.splice(index, 1);
  }

  onReceiptUpload(form) {
    const userId = this.authService.getUserId();
    const IsReUpload = localStorage.getItem('IsReUpload');
    this.List = [];

    this.selectedProducts.map((prod:any) => {
      let product = this.findProductByName(prod.productName) || {};
      let data = {
        'ProductId': prod.productId,
        'ProductName': prod.productName,
        'Category': product.category || '',
        'Quantity': prod.quantity,
        'PointsPerProduct': product.pointsPerProduct || 0
      }
      this.List.push(data);
    })

    this.showAnimationPopup();

    
    localStorage.setItem('productList', JSON.stringify(this.List));
    const formData = new FormData();
    formData.append("UserId", userId);
    formData.append("Quantity", this.Quantity.toString());
    formData.append("Culture", this.translate.getDefaultLang());
    formData.append("File", this.receipt);
    formData.append("IsReUpload", IsReUpload === "1" ? "true" : "false");
    formData.append("Purchases", JSON.stringify(this.List));

    if (this.isFinnish) {
      formData.append("IsKotiPizzaStore", this.IsKotiPizzaStore ? "true" : "false");
    }

        this.coreService
      .upLoadReceipt(formData)
      .then(async (res: any) => {
        localStorage.removeItem('modalDisplayed')
        this.modalRef.hide();
        form.submitted = false;
        this.resetForm();
        //this.toast.success(this.translate.instant('' + res.messageKey), this.translate.instant('success'));
        this.receiptUploadSuccess.emit(res.result);

        if (res.result.isnewRegistration) {
          this.gaService.emitEvent("Registration", "success");
        }
        this.coreService.rejectedReasons = res.result.rejectedReasons || [];


        if (!res.result.isapproved && res.result.tryagain) {
          this.removeLocalProductList  = false;
          this.modalRef = this.modalService.show(
            this.tryagainReceiptUploadRef,
            this.confirmPopupConfig
          );
          return;
        }

        if (
          !res.result.isapproved &&
          res.result.recptPartitionKey &&
          res.result.recptRowKey
        ) {
          this.removeLocalProductList = false;
          //this.authService.setToken(res.result.token, res.result.id);
          const receiptNotApprovedData = {
            ...res.result,
            feedbackMessages: res.feedbackMessages || []
          };
          this.dataService.setReceiptNotApprovedData(receiptNotApprovedData);
          this.showConfirmReceiptUploadPopUp = true;
          return;
        }
        if (res.result.isapproved) {
          const weatherResult = await this.weatherBonusOrchestrator.applyFromUploadResult(res.result);
          if (weatherResult.status === 'applied') {
            this.toast.success('Rain bonus applied', '');
          }
          await this.prepareApprovedPopup(res.result, weatherResult);
          this.coreService.pointsEmitter.emit(true);
          localStorage.removeItem('productList');
          localStorage.setItem("IsReUpload", "0");
          this.modalRef = this.modalService.show(this.thankyouApprovedPopupRef, this.confirmPopupConfig);
        }
      })
      .catch((errorResponse: any) => {
        // this.resetForm();
        const errorMessage = this.translate.instant(
          errorResponse.error.messageKey
        );
        this.toast.error(errorMessage, "");
        return;
      });
  }

  tryAgain() {
    this.resetForm();
    this.modalRef.hide();
    this.router.navigate(["/upload"]);
  }

  resetForm() {
    this.ReceiptName = "";
    this.Quantity = 1;
    this.receipt = undefined;
    this.selectedProducts = [{ productId: null, productName: null, quantity: 0 }];
    this.List = [];
  }

  async prepareApprovedPopup(uploadResult: any, weatherResult: WeatherBonusFrontendResult) {
    this.approvedPopupTitle = this.translationOrFallback(
      "receipt-approved-title",
      "Your receipt has been approved!"
    );

    const points = await this.getUpdatedPoints(uploadResult);
    this.setApprovedPointsMessage(points);

    this.approvedPopupBonusMessage = this.buildWeatherBonusMessage(weatherResult);
    this.approvedPopupBonusIsWarning = this.isWeatherBonusWarning(weatherResult);
    this.approvedPopupBonusIsSuccess = !!(weatherResult && weatherResult.status === "applied");
    this.setApprovedBonusMessageParts(weatherResult);
  }

  setApprovedPointsMessage(points: any) {
    this.approvedPopupPointsValue = "";
    this.approvedPopupPointsPrefix = "";
    this.approvedPopupPointsSuffix = "";

    if (points === null || points === undefined) {
      this.approvedPopupPoints = this.translationOrFallback(
        "receipt-approved-points-unavailable",
        "Your points have been updated."
      );
      return;
    }

    const template = this.translationOrFallback("receipt-approved-points", "You now have {{points}} points.");
    const parts = this.splitTemplateAtPlaceholder(template, "points");
    this.approvedPopupPoints = this.interpolate(template, { points });
    this.approvedPopupPointsPrefix = parts.prefix;
    this.approvedPopupPointsValue = String(points);
    this.approvedPopupPointsSuffix = parts.suffix;
  }

  async getUpdatedPoints(uploadResult: any): Promise<any> {
    const resultPoints = this.findPointsValue(uploadResult);
    if (resultPoints !== null && resultPoints !== undefined) {
      return resultPoints;
    }

    const userId = this.authService.getUserId();
    if (!userId) {
      return null;
    }

    try {
      const pointsResponse: any = await this.coreService.getPoints(userId);
      return pointsResponse && pointsResponse.result ? pointsResponse.result.points : null;
    } catch (error) {
      return null;
    }
  }

  findPointsValue(result: any) {
    if (!result) {
      return null;
    }

    const pointKeys = ["points", "Points", "totalPoints", "TotalPoints", "currentPoints", "CurrentPoints"];
    for (const key of pointKeys) {
      if (result[key] !== null && result[key] !== undefined) {
        return result[key];
      }
    }

    if (result.user && result.user.points !== null && result.user.points !== undefined) {
      return result.user.points;
    }

    return null;
  }

  buildWeatherBonusMessage(weatherResult: WeatherBonusFrontendResult) {
    if (weatherResult && weatherResult.status === "applied") {
      const bonusPoints = weatherResult.response && weatherResult.response.weatherBonusPoints;
      return bonusPoints
        ? this.interpolate(
            this.translationOrFallback(
              "receipt-approved-weather-bonus-applied-with-points",
              "Rain was verified at the time of purchase, so double points were applied. You received {{points}} bonus points."
            ),
            { points: bonusPoints }
          )
        : this.translationOrFallback(
            "receipt-approved-weather-bonus-applied",
            "Rain was verified at the time of purchase, so double points were applied."
          );
    }

    return "";
  }

  setApprovedBonusMessageParts(weatherResult: WeatherBonusFrontendResult) {
    this.approvedPopupBonusPrefix = "";
    this.approvedPopupBonusPoints = "";
    this.approvedPopupBonusSuffix = "";

    if (!weatherResult || weatherResult.status !== "applied") {
      return;
    }

    const bonusPoints = weatherResult.response && weatherResult.response.weatherBonusPoints;
    if (!bonusPoints) {
      return;
    }

    const template = this.translationOrFallback(
      "receipt-approved-weather-bonus-applied-with-points",
      "Rain was verified at the time of purchase, so double points were applied. You received {{points}} bonus points."
    );
    const parts = this.splitTemplateAtPlaceholder(template, "points");
    this.approvedPopupBonusPrefix = parts.prefix;
    this.approvedPopupBonusPoints = String(bonusPoints);
    this.approvedPopupBonusSuffix = parts.suffix;
  }

  isWeatherBonusWarning(weatherResult: WeatherBonusFrontendResult) {
    return false;
  }

  translationOrFallback(key: string, fallback: string) {
    const translated = this.translate.instant(key);
    return translated && translated.indexOf("✎") === -1 && translated !== key ? translated : fallback;
  }

  interpolate(template: string, values: { [key: string]: any }) {
    return Object.keys(values).reduce((text, key) => {
      return text.replace(new RegExp(`{{\\s*${key}\\s*}}`, "g"), values[key]);
    }, template);
  }

  splitTemplateAtPlaceholder(template: string, placeholder: string) {
    const pattern = new RegExp(`{{\\s*${placeholder}\\s*}}`);
    const match = template.match(pattern);
    if (!match) {
      return {
        prefix: template,
        suffix: ""
      };
    }

    return {
      prefix: template.slice(0, match.index),
      suffix: template.slice((match.index || 0) + match[0].length)
    };
  }

  surveyTaken() {
    localStorage.setItem("surveyTaken", "true");
    this.showSurvey = false;
  }

  ngOnDestroy() {
    if (this.removeLocalProductList) {
      localStorage.removeItem('productList');
    }
  }
}
